import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

export const getModuleColumns = () => [
  {
    id: 'moduleSelect',
    label: 'Select',
  },
  {
    id: 'imageUrl',
    disablePadding: true,
    label: 'Image',
  },
  {
    id: 'title',
    disablePadding: true,
    label: 'Module Name',
  },
  {
    id: 'isPlatformWide',
    disablePadding: true,
    label: 'Platform Wide',
  },
  {
    id: 'Action',
    disablePadding: true,
    label: 'Action',
  },
];

const createSortHandler = (property, onRequestSort) => (event) => {
  onRequestSort(event, property);
};

const ModuleTableColumns = ({ order, orderBy, onRequestSort }) => (
  <Fragment>
    <TableRow>
      {getModuleColumns().map((row) => (
        <TableCell
          className="material-table__cell material-table__cell--sort material-table__cell-center"
          key={row.id}
          align={'center'}
          padding={row.disablePadding ? 'none' : 'default'}
          sortDirection={orderBy === row.id ? order : false}
        >
          <TableSortLabel
            active={orderBy === row.id}
            direction={order}
            onClick={createSortHandler(row.id, onRequestSort)}
            className="material-table__sort-label"
            dir="ltr"
          >
            <b>{row.label}</b>
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  </Fragment>
);

ModuleTableColumns.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(ModuleTableColumns);
